export function ModalIcon({ children }) {
  return (
    <div className="mx-auto my-8 h-20 w-20 flex-shrink-0 items-center justify-center rounded-full">
      {children}
    </div>
  );
}
